export default __webpack_public_path__ + "static/media/img-1.c8a39a7a.jpg";